export default __webpack_public_path__ + "static/media/logo.8898ed20.svg";